import { render, staticRenderFns } from "./EmailCor.vue?vue&type=template&id=5399a438&scoped=true&"
import script from "./EmailCor.vue?vue&type=script&lang=js&"
export * from "./EmailCor.vue?vue&type=script&lang=js&"
import style0 from "./EmailCor.vue?vue&type=style&index=0&id=5399a438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399a438",
  null
  
)

export default component.exports